module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-1 md-scrollbar md-theme-default",
    attrs: {
      "id": "entity-property-values"
    }
  }, [_c('div', {
    staticClass: "md-layout-row header"
  }, [_c('div', {
    staticClass: "md-flex"
  }, [_c('md-button', {
    staticClass: "md-icon-button md-dense close small",
    attrs: {
      "to": {
        name: 'Entity',
        params: {
          code: _vm.$route.params.code,
          entity_code: _vm.$route.params.entity_code
        },
        query: _vm.$route.query
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1), (_vm.values.length && _vm.property) ? _c('div', _vm._l((_vm.values), function(value, key) {
    return _c('div', {
      key: key
    }, [_c('div', {
      staticClass: "value-header"
    }, [_c('span', [_vm._v("Значение " + _vm._s((key + 1)))]), (key > 0) ? _c('md-button', {
      staticClass: "md-dense md-icon-button",
      on: {
        "click": function($event) {
          _vm.removePropertyValue(key)
        }
      }
    }, [_c('md-icon', [_vm._v("delete")])], 1) : _vm._e()], 1), _c('md-field', [_c('label', [_vm._v("Символьный код")]), _c('md-input', {
      model: {
        value: (value['code']),
        callback: function($$v) {
          _vm.$set(value, 'code', $$v)
        },
        expression: "value['code']"
      }
    })], 1), _c('md-field', [_c('label', [_vm._v("Значение")]), _c('md-input', {
      model: {
        value: (value['name']),
        callback: function($$v) {
          _vm.$set(value, 'name', $$v)
        },
        expression: "value['name']"
      }
    })], 1), _c('md-field', [_c('label', [_vm._v("Сортировка")]), _c('md-input', {
      attrs: {
        "type": "number"
      },
      model: {
        value: (value['sort']),
        callback: function($$v) {
          _vm.$set(value, 'sort', $$v)
        },
        expression: "value['sort']"
      }
    })], 1), _c('br')], 1)
  })) : _vm._e(), _c('md-button', {
    staticClass: "md-dense",
    on: {
      "click": function($event) {
        _vm.values.push({
          code: '',
          name: '',
          sort: 100
        })
      }
    }
  }, [_vm._v("Добавить значение "), _c('md-icon', [_vm._v("add")])], 1), _c('br'), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.pushValues()
      }
    }
  }, [_vm._v("Сохранить")]), _c('md-button', {
    staticClass: "md-accent",
    attrs: {
      "to": {
        name: 'Entity',
        params: {
          code: _vm.$route.params.code,
          entity_code: _vm.$route.params.entity_code
        },
        query: _vm.$route.query
      }
    }
  }, [_vm._v("Отмена")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-268d903f","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/views/EntityPropertyValues.vue
// module id = 1075
// module chunks = 0